
export const SESSION_VALID = 'SESSION_VALID';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';



// WEBPACK FOOTER //
// ./src/components/Session/SessionActionTypes.js